export default __webpack_public_path__ + "static/media/cars (2).d8176ad4.png";